import classNames from 'classnames';
import { Typography, TypographyWeight } from '../../../../components/typography/typography';

export const CheckoutLineItem = ({
  label,
  amount,
  noAmountText = '-',
  taxInclusive = false,
  taxLabel,
  tax,
  weigth = 'regular',
  className = 'px-3',
  dataCy,
}: {
  label: string;
  amount?: Dinero.Dinero;
  noAmountText?: string;
  taxInclusive?: boolean;
  taxLabel?: string;
  tax?: Dinero.Dinero;
  weigth?: keyof typeof TypographyWeight;
  className?: string;
  dataCy?: string;
}) => (
  <div className={classNames('flex justify-between', className)} data-cy={dataCy}>
    <Typography type="text-sm" weight={weigth} className="text-quipli-black-500">
      {label}
    </Typography>
    <Typography type="text-sm" weight={weigth} dataCy="checkout-line-item-amount">
      {amount
        ? amount.toFormat() +
          `${
            taxInclusive
              ? tax && !tax.isZero()
                ? ` incl. ${taxLabel ?? 'Tax'}`
                : ` no ${taxLabel ?? 'Tax'} incl.`
              : ''
          }`
        : noAmountText}
    </Typography>
  </div>
);
